import { useGetMzcrContextQuery } from './mzcrApi';

export type { MzcrContext } from './mzcrApi';

/**
 * Za koho se služby MZČR volají – pracoviště s IČO a přihlášený lékař (z user-api). Načítá se jednou
 * a sdílí se (cache), `refetch` načte znovu po chybě.
 */
export const useMzcrContext = (options?: { skip?: boolean }) => {
	const query = useGetMzcrContextQuery(undefined, options);

	return {
		context: query.data ?? null,
		isLoading: query.isLoading,
		isError: query.isError,
		isRefetching: query.isFetching,
		refetch: query.refetch,
	};
};
